import { createApi } from '@reduxjs/toolkit/query/react'
import { createApiConfig } from '../../../createApiConfig'

export const lMUgcSeasonApi = createApi({
  reducerPath: 'lMUgcSeasonApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['UgcSeasonLinks'],
  endpoints: builder => ({
    getUgcSeasonLinks: builder.query({
      query: (params) => ({
        url: `/links/ugc-season-level/`,
        params,
      }),
      providesTags: ['UgcSeasonLinks']
    }),
    getUgcSeasonAggregateLinks: builder.query({
      query: (params) => ({
        url: `/links/ugc-season-level/aggregate-by-campaign/`,
        params
      }),
      providesTags: ['UgcSeasonLinks']
    }),
    getUgcSeasonAggregateDomain: builder.query({
      query: ({ campaignId, ...params }) => ({
        url: `/links/ugc-season-level/${campaignId}/aggregate-by-domain/`,
        params,
      }),
      providesTags: ['UgcSeasonLinks']
    }),
    markUgcSeason: builder.mutation({
      query: body => ({
        url: `/links/ugc-season-level/mark/`,
        method: 'POST',
        body
      }),
      invalidatesTags: ['UgcSeasonLinks']
    })
  })
})

export const {
  useGetUgcSeasonLinksQuery,
  useGetUgcSeasonAggregateLinksQuery,
  useGetUgcSeasonAggregateDomainQuery,
  useMarkUgcSeasonMutation
} = lMUgcSeasonApi
